<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div
		class="vs-sidebar--item"
		:class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]">

		<div v-if="to">
			<a v-if="location() === to" :target="target" :href="to" :class="[{'router-link-active': activeLink}]"
			   tabindex="-1">
				<font-awesome-icon class="fa-icon" :icon="icon" />
				<slot />
			</a>

			<router-link
				tabindex="-1"
				v-else
				exact
				:class="[{'router-link-active': activeLink}]"
				:to="to"
				:target="target">
				<font-awesome-icon class="fa-icon" :icon="icon" />
				<slot />
			</router-link>
		</div>


		<a v-else :target="target" :href="href" tabindex="-1">
			<font-awesome-icon class="fa-icon" :icon="icon" />
			<slot />
		</a>
	</div>
</template>

<script>
export default {
	name: 'v-nav-menu-item',
	props: {
		icon: {
			type: Array | String,
			default: ''
		},
		href: {
			type: [String, null],
			default: '#'
		},
		to: {
			type: [String, Object, null],
			default: null
		},
		slug: {
			type: String,
			default: null
		},
		index: {
			type: [String, Number],
			default: null
		},
		target: {
			type: String,
			default: '_self'
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		activeLink() {
			if (!this.to) return false;

			const currentPath = this.$route.path;
			const menuPath = this.to;

			// Exacte match
			if (currentPath === menuPath) return true;

			// Parent match via metadata
			if (this.$route.meta.parent === this.slug) return true;



			// Segment-based match for nested routes
			if (typeof menuPath === 'string') {
				const menuSegments = menuPath.split('/').filter(Boolean);
				const currentSegments = currentPath.split('/').filter(Boolean);

				if (menuSegments.length > 0) {
					// For single-segment paths like /products: require exact match
					// This prevents /products from being active when on /products/pools/edit/3
					if (menuSegments.length === 1) {
						return currentPath === menuPath;
					}

					// For multi-segment paths like /products/pools: allow prefix matching
					// This makes /products/pools active when on /products/pools/edit/3
					if (currentSegments.length >= menuSegments.length) {
						const match = menuSegments.every((segment, index) => segment === currentSegments[index]);
						return match;
					}
				}
			}

			return false;
		}
	},
	methods: {
		location() {
			return window.location.pathname;
		}
	}
}

</script>

